import { ChevronRight } from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  Skeleton,
  Typography,
} from "@mui/material";
import { Link as LinkBase } from "react-router-dom";
import { useGetWellnessResourceQuery } from "graphql/__generated__/hooks";
import { useEffect, useState } from "react";
import { WellnessResource } from "types/wellnessResource";

export const WellnessDEIB = () => {
  const [wellnessResources, setWellnessResources] = useState(
    [] as WellnessResource[],
  );
  const { data } = useGetWellnessResourceQuery();

  useEffect(() => {
    setWellnessResources((data?.wellness_resource as WellnessResource[]) || []);
  }, [data]);

  if (!data) return <Skeleton variant="rounded" height={300} />;

  if ((data.wellness_resource || []).length === 0) return null;

  return (
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" gutterBottom>
            Wellness
          </Typography>
          <Link
            sx={{ textDecoration: "none" }}
            component={LinkBase}
            to="/wellness-resources"
          >
            VIEW ALL
          </Link>
        </Box>

        <List>
          {wellnessResources.map((element) => (
            <ListItem
              key={element.wellness_resource_id}
              secondaryAction={
                <IconButton
                  edge="end"
                  aria-label="delete"
                  component={LinkBase}
                  to={`/wellness-resource/view/${element.wellness_resource_id}`}
                >
                  <ChevronRight />
                </IconButton>
              }
            >
              <ListItemText
                primary={element.name}
                secondary={element.description}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
